import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { images } from "../assets";

import { DialogContextType } from "../../DialogComponents/FullScreenDialog";

export const useContext = (): DialogContextType => {
  const { t } = useTranslation("dialogs");

  return useMemo(
    () => ({
      title: {
        text: t("geometrySelection.geometrySelection"),
        icon: "tools_spatial_selection",
      },
      help: {
        hintsBlock: {
          title: t("geometrySelection.dialogHintBlock"),
          hints: [
            {
              img: images.initial,
              label: t("geometrySelection.sourceLayerFeatures"),
            },
            { icon: "plus" },
            {
              img: images.geometryWithoutInfo,
              label: t("geometrySelection.layerWithGeometry"),
            },
            { icon: "arrow_forward" },
          ],
        },
      },
    }),
    [t],
  );
};
